import { render, staticRenderFns } from "./YearOverviewChart.vue?vue&type=template&id=2cdbf106&"
import script from "./YearOverviewChart.vue?vue&type=script&lang=js&"
export * from "./YearOverviewChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports